import { render, staticRenderFns } from "./KInput.vue?vue&type=template&id=bb7f7fc0&scoped=true&lang=pug&"
import script from "./KInput.vue?vue&type=script&lang=ts&"
export * from "./KInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7f7fc0",
  null
  
)

export default component.exports